import { Icon, MockAvatar, MockBubble } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/**
 * Pane 0 của mock app — `template.html:674`. Kênh chat: header kênh, hàng topic, 3 tin nhắn,
 * ô soạn tin.
 *
 * Tin nhắn thứ hai là tin của "mình" (bong bóng brand, đảo chiều) — thiết kế đánh dấu bằng
 * `flex-direction:row-reverse` chứ không bằng dữ liệu, nên chỉ số 1 ở đây là số ĐO được, không
 * phải quy ước tự đặt.
 */
const OUTGOING_INDEX = 1;

export function ChatPane() {
  const chat = useCopy().hero.mock.chat;

  return (
    <div className="flex h-full flex-col">
      <div className="flex h-[54px] items-center gap-2.5 border-b border-ink-100 bg-surface px-[18px]">
        <Icon name="hash" size={15} className="text-ink-400" />
        <span className="text-body font-bold text-ink-mock-900">{chat.channel}</span>
        <span className="text-caption text-ink-400">· {chat.members}</span>
        <span className="ml-auto flex gap-3.5 text-ink-400">
          <Icon name="phone" size={16} />
          <Icon name="video" size={16} />
          <Icon name="panel-right" size={16} />
        </span>
      </div>

      <div className="flex gap-2 border-b border-ink-100 bg-surface px-[18px] py-2.5">
        {chat.topics.map((topic, index) => (
          <span
            key={topic}
            className={
              index === 0
                ? 'rounded-pill bg-brand-600 px-3 py-[5px] text-eyebrow leading-[normal] font-semibold text-white'
                : 'rounded-pill bg-surface-mock px-3 py-[5px] text-eyebrow leading-[normal] font-medium text-ink-700'
            }
          >
            {topic}
          </span>
        ))}
      </div>

      <div className="flex flex-1 flex-col gap-3 overflow-hidden p-[18px]">
        {chat.messages.map((message, index) => {
          const outgoing = index === OUTGOING_INDEX;
          return (
            <div
              key={message.author}
              className={`flex gap-2.5 ${outgoing ? 'flex-row-reverse' : ''}`}
            >
              <MockAvatar initials={message.initials} tint={message.tint} />
              <div className={outgoing ? 'text-right' : ''}>
                <div className="mb-1 text-eyebrow leading-[normal] text-ink-400">
                  {message.author} · {message.time}
                </div>
                <MockBubble direction={outgoing ? 'out' : 'in'} className="max-w-[42ch] text-left">
                  {message.text}
                </MockBubble>
              </div>
            </div>
          );
        })}

        <div className="mt-auto flex items-center gap-2 rounded-pill border border-ink-100 bg-surface px-4 py-[9px] text-body-sm text-ink-400">
          <Icon name="plus" size={15} />
          <span>{chat.composer}</span>
          <span className="ml-auto flex gap-3">
            <Icon name="smile" size={15} />
            <Icon name="clock" size={15} />
            <Icon name="send-horizontal" size={15} className="text-brand-600" />
          </span>
        </div>
      </div>
    </div>
  );
}
